import { ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ChangePasswordForm } from "@/components/ChangePasswordForm";
import { useAuth } from "@/context/AuthContext";

export default function ForceChangePassword() {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen grid place-items-center bg-[#FBF9F4] p-6" data-testid="force-change-password-page">
      <div className="w-full max-w-sm bf-rise">
        <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-2xl bg-[#0F382C] text-[#F2B880]"><ShieldCheck className="h-6 w-6" /></div>
        <h1 className="font-display text-3xl font-extrabold text-[#0F382C]">Set your own password</h1>
        <p className="mt-2 mb-8 text-sm text-muted-foreground">Hi {user.name}, for security you need to choose a new password that only you know before you continue.</p>
        <ChangePasswordForm />
        <Button variant="ghost" onClick={logout} className="mt-3 w-full rounded-full" data-testid="force-cp-logout-btn">Log out</Button>
      </div>
    </div>
  );
}
